authTokenNewRelicFailureData